import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Form, Input as AntInput } from 'antd'
import { get } from 'lodash-es'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { THEME } from '../constants'

const StyledInput = styled.div`
  .ant-input {
    color: ${props => props.color};
    border-color: ${props => props.color};
  }
`

const getColor = highlighted =>
  highlighted ? THEME.colors.lavender : undefined

const Input = ({ name, label, required, highlighted, ...rest }) => {
  const { control, errors } = useFormContext()
  const { message: errorMessage } = get(errors, name, {})

  return (
    <Form.Item
      label={label}
      required={required}
      help={errorMessage}
      validateStatus={errorMessage ? 'error' : 'success'}
    >
      <Controller
        control={control}
        name={name}
        render={props => (
          <StyledInput color={getColor(highlighted)}>
            <AntInput {...props} {...rest} />
          </StyledInput>
        )}
      />
    </Form.Item>
  )
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  highlighted: PropTypes.bool,
}

Input.defaultProps = {
  label: '',
  required: false,
  highlighted: false,
}

export default Input
